import { render, staticRenderFns } from "./DelegationSubstitutesMenu.vue?vue&type=template&id=62efcc60&scoped=true&"
import script from "./DelegationSubstitutesMenu.vue?vue&type=script&lang=js&"
export * from "./DelegationSubstitutesMenu.vue?vue&type=script&lang=js&"
import style0 from "./DelegationSubstitutesMenu.vue?vue&type=style&index=0&id=62efcc60&scoped=true&lang=css&"
import style1 from "./DelegationSubstitutesMenu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62efcc60",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62efcc60')) {
      api.createRecord('62efcc60', component.options)
    } else {
      api.reload('62efcc60', component.options)
    }
    module.hot.accept("./DelegationSubstitutesMenu.vue?vue&type=template&id=62efcc60&scoped=true&", function () {
      api.rerender('62efcc60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DelegationSubstitutesMenu.vue"
export default component.exports